import React, { useMemo } from "react";
import { useMatch, useParams } from "react-router-dom";
import { Page } from "@/layout/Page";
import { Section } from "@/layout/Section";
import { useQ } from "@/hooks/useQ";
import { project } from "@/queries";
import { IssueRegister } from "./components/IssueRegister";
import { useT } from "@/hooks/useT";

export const Change = () => {
  const { t } = useT();
  const { id = "", issueId } = useParams();

  const { isLoading, data = {} } = useQ(`project-${id}`, () =>
    project.single({ id }),
  );

  const { title } = data;

  return (
    <Page isLoading={isLoading} title={title}>
      <Section title={t("project.navigation.change.title")}>
        <IssueRegister projectId={id} type={"project"} issueId={issueId} />
      </Section>
    </Page>
  );
};
